import React from 'react';

import AllContentsIcon from 'assets/icons/all-contents.svg';
import CategoriesIcon from 'assets/icons/categories.svg';
import HomeIcon from 'assets/icons/home.svg';
import LibraryIcon from 'assets/icons/library-books.svg';
import Search from 'assets/icons/search.svg';
import SettingsIcon from 'assets/icons/settings.svg';
import UserIcon from 'assets/icons/user.svg';

import { ERoute } from 'types/enums/ERoute';
import { ESidebarType } from 'types/enums/ESidebarType';
import { EUrlSearchParam } from 'types/enums/EUrlSearchParam';
import { ISidebarMenuItem } from 'types/interfaces/ISidebar';
import { INavigation } from 'types/interfaces/sulu/INavigation';

import currentLanguage from './sulu/currentLanguage';

export default (
  sidebarType: ESidebarType,
  subMenuItems: INavigation[] = [],
  consultantId: string = '',
): ISidebarMenuItem[] => {
  // sort sub menu items by their sulu order
  subMenuItems.sort((a, b) => a.order - b.order);

  const sidebarMenuItems: ISidebarMenuItem[] = [
    {
      url: `/${currentLanguage}`,
      icon: <HomeIcon className='icon' />,
      label: 'Startseite',
    },
    {
      url: `/${currentLanguage}/${ERoute.ALL_CONTENTS}`,
      icon: <AllContentsIcon className='icon' />,
      label: 'Alle Inhalte',
    },
    {
      url: `/${currentLanguage}/${ERoute.CONSULTANT_OVERVIEW}`,
      icon: <Search className='icon' />,
      label: 'Berater Suche',
    },
  ];

  switch (sidebarType) {
    case ESidebarType.TOPICS:
      sidebarMenuItems.push({
        icon: <CategoriesIcon className='icon' />,
        label: 'Themen',
        subMenuItems,
      });
      break;
    case ESidebarType.PROFILE:
      sidebarMenuItems.push(
        {
          url: `/${currentLanguage}/${ERoute.SETTINGS}`,
          icon: <SettingsIcon className='icon' />,
          label: 'Einstellungen',
          style: 'ml-4 mt-4',
        },
        {
          url: `/${currentLanguage}/${ERoute.MY_LIBRARY}`,
          icon: <LibraryIcon className='icon' />,
          label: 'Meine Bibliothek',
          style: 'ml-4',
        },
      );
      break;
    case ESidebarType.CONSULTANT:
      sidebarMenuItems.push(
        {
          url: `/${currentLanguage}/${ERoute.CONSULTANT_WELCOME}${
            consultantId
              ? `?${EUrlSearchParam.CONSULTANT_ID}=${consultantId}`
              : ''
          }`,
          icon: <CategoriesIcon className='icon' />,
          label: 'Übersicht',
          style: 'ml-4 mt-4',
        },
        {
          url: `/${currentLanguage}/${ERoute.CONSULTANT_PROFILE}${
            consultantId
              ? `?${EUrlSearchParam.CONSULTANT_ID}=${consultantId}`
              : ''
          }`,
          icon: <UserIcon className='icon' />,
          label: 'Mein Profil',
          style: 'ml-4',
        },
        {
          url: `/${currentLanguage}/${ERoute.SETTINGS}${
            consultantId
              ? `?${EUrlSearchParam.CONSULTANT_ID}=${consultantId}`
              : ''
          }`,
          icon: <SettingsIcon className='icon' />,
          label: 'Einstellungen',
          style: 'ml-4',
        },
        {
          url: `/${currentLanguage}/${ERoute.CONSULTANT_ARTICLES_OVERVIEW}${
            consultantId
              ? `?${EUrlSearchParam.CONSULTANT_ID}=${consultantId}`
              : ''
          }`,
          icon: <LibraryIcon className='icon' />,
          label: 'Meine Beiträge',
          style: 'ml-4',
        },
      );
      break;
    case ESidebarType.DEFAULT:
    default:
      break;
  }

  return sidebarMenuItems;
};
